import { CommentaryV2 } from '@aloft/toolkit-shared';
import { Flex, Input, Typography } from '@aloft/toolkit-sui';

import { FieldPath, useFormContext } from 'react-hook-form';

import { DepreciatedCost } from '../../commentary/DepreciatedCost/DepreciatedCost.tsx';

export const DepreciatedCostTabPanels = () => null;

DepreciatedCostTabPanels.LeftPanel = () => {
  const { setValue, watch } = useFormContext<CommentaryV2>();

  const glaCommentaryFieldName: FieldPath<CommentaryV2> = 'depreciatedCost.glaCommentary';
  const bathCommentaryFieldName: FieldPath<CommentaryV2> = 'depreciatedCost.bathCommentary';
  const basementCommentaryFieldName: FieldPath<CommentaryV2> = 'depreciatedCost.basementCommentary';
  const qualityCommentaryFieldName: FieldPath<CommentaryV2> = 'depreciatedCost.qualityCommentary';
  const conditionCommentaryFieldName: FieldPath<CommentaryV2> =
    'depreciatedCost.conditionCommentary';
  const garageCarportCommentaryFieldName: FieldPath<CommentaryV2> =
    'depreciatedCost.garageCarportCommentary';
  const porchPatioDeckCommentaryFieldName: FieldPath<CommentaryV2> =
    'depreciatedCost.porchPatioDeckCommentary';
  const aduCommentaryFieldName: FieldPath<CommentaryV2> = 'depreciatedCost.aduCommentary';
  const poolCommentaryFieldName: FieldPath<CommentaryV2> = 'depreciatedCost.poolCommentary';
  const shedCommentaryFieldName: FieldPath<CommentaryV2> = 'depreciatedCost.shedCommentary';

  const glaCommentary = watch(glaCommentaryFieldName);
  const bathCommentary = watch(bathCommentaryFieldName);
  const basementCommentary = watch(basementCommentaryFieldName);
  const qualityCommentary = watch(qualityCommentaryFieldName);
  const conditionCommentary = watch(conditionCommentaryFieldName);
  const garageCarportCommentary = watch(garageCarportCommentaryFieldName);
  const porchPatioDeckCommentary = watch(porchPatioDeckCommentaryFieldName);
  const aduCommentary = watch(aduCommentaryFieldName);
  const poolCommentary = watch(poolCommentaryFieldName);
  const shedCommentary = watch(shedCommentaryFieldName);

  const commentaryFields = [
    { label: 'GLA Commentary', value: glaCommentary, fieldName: glaCommentaryFieldName },
    { label: 'Bath Commentary', value: bathCommentary, fieldName: bathCommentaryFieldName },
    {
      label: 'Basement Commentary',
      value: basementCommentary,
      fieldName: basementCommentaryFieldName,
    },
    {
      label: 'Quality Commentary',
      value: qualityCommentary,
      fieldName: qualityCommentaryFieldName,
    },
    {
      label: 'Condition Commentary',
      value: conditionCommentary,
      fieldName: conditionCommentaryFieldName,
    },
    {
      label: 'Garage/Carport Commentary',
      value: garageCarportCommentary,
      fieldName: garageCarportCommentaryFieldName,
    },
    {
      label: 'Porch/Patio/Deck Commentary',
      value: porchPatioDeckCommentary,
      fieldName: porchPatioDeckCommentaryFieldName,
    },
    { label: 'ADU Commentary', value: aduCommentary, fieldName: aduCommentaryFieldName },
    { label: 'Pool Commentary', value: poolCommentary, fieldName: poolCommentaryFieldName },
    { label: 'Shed Commentary', value: shedCommentary, fieldName: shedCommentaryFieldName },
  ];

  return (
    <Flex flexDirection="column" padding="1rem" gap="1.5rem" width="100%">
      <Typography variant="h2">Depreciated Cost</Typography>
      {commentaryFields.map(({ label, value, fieldName }) => (
        <Input
          key={label}
          type="multiline"
          resize="vertical"
          label={label}
          value={value}
          onChange={(v) => setValue(fieldName, v)}
          onClear={() => setValue(fieldName, undefined)}
        />
      ))}
    </Flex>
  );
};

DepreciatedCostTabPanels.RightPanel = () => <DepreciatedCost />;
